const getCometChatConfig = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isQA =
      hostname.includes('qa') ||
      hostname === 'localhost' ||
      hostname === '127.0.0.1';

    if (isQA) {
      return {
        APP_ID: '168305471b5c86235',
        REGION: 'in',
        AUTH_KEY: 'd5295d6af5bc5af1bc67de00c330098014961608',
      };
    }

    return {
      APP_ID: '1683056a57e16ed43',
      REGION: 'in',
      AUTH_KEY: '09069f6dde13990f45d60d7e79a7741dc2119e3f',
    };
  }

  return {
    APP_ID: '168305471b5c86235',
    REGION: 'in',
    AUTH_KEY: 'd5295d6af5bc5af1bc67de00c330098014961608',
  };
};

export const COMETCHAT_CONFIG = getCometChatConfig();
